import { ExclamationCircleOutlined } from '@ant-design/icons';
import { OrderVehicleReminder } from '@components';
import { useStore } from '@stores';
import { Col, Collapse, Row } from 'antd';
import { observer } from 'mobx-react';
import React from 'react';

interface IProps {
  vin: string;
  customerId: string;
  registrationNumber: string;
  currentMileage?: number;
}

export const VehicleReminderCollapse: React.FC<IProps> = observer(
  ({ vin, customerId, registrationNumber, currentMileage }) => {
    const { reminderStore } = useStore();
    const { overdueVehicleReminderCount } = reminderStore;
    return (
      <Row style={{ marginTop: '20px' }}>
        <Col span={24}>
          <Collapse defaultActiveKey={['1']}>
            <Collapse.Panel
              key="1"
              header={
                <>
                  Reminders
                  {(overdueVehicleReminderCount && (
                    <ExclamationCircleOutlined style={{ color: 'red', marginLeft: '10px' }} />
                  )) ||
                    null}
                </>
              }
            >
              <OrderVehicleReminder
                vin={vin}
                customerId={customerId}
                registrationNumber={registrationNumber}
                currentMileage={currentMileage}
              />
            </Collapse.Panel>
          </Collapse>
        </Col>
      </Row>
    );
  }
);
